import(/* webpackMode: "eager" */ "/work/web/app/safe/src/app/page.tsx");
